export const initialState = {
  shop: {
    lingua: "",
    scroll: 0,
    vista: "intera",
    rotazione: true,
    cameraOrbit: [0, 0, 55],
    fieldOfView: 55,
    customization: "tessuti",
    personalizzazione: "colletti",
    search: "",
    openMain: "",
    filtri: false,
    filtriPersonalizza: false,
    colore: "",
    disegno: "",
    materiale: "",
    brand: "",
    flagIntera: true, //disabilitato
    flagLegenda: true, //disabilitato
    camicia: {
      colletto: 0,
      durezzaColletto: "Normale",
      vela: "Vela 7",
      polsino: 0,
      mask: false,
      club: false,
      chiusura: 0,
      taschino: 0,
      contrasto: 0,
      contrastoColletto: true,
      contrastoPolsino: true,
      contrastoChiusura: true,
      asola: -1,
      bottone: 0,
      filo: 0,
      elastico: 0,
      pince: 0,
      fondo: 0,
      iniziali: {
        attiva: false,
        testo: "",
        stile: "block",
        colore: 0,
        posizione: 0,
      },
      accordion: {
        vestibilita: false,
        corporatura: false,
        spalle: false,
      },
      misure: {
        neutra: false,
        taglia: "l",
        tipo: 0, // 0=taglia 1=corpo 2=camicia 3=invio
        fit: "Regular",
        corporaturaPancia: "Regolare",
        corporaturaSpalle: "Regolari",
        braccia: 65,
        bicipite: 32,
        avambraccio: 26,
        collo: 39,
        girovita: 100,
        fianco: 110,
        puntoVitaDietro: 45,
        lunghezza: 75,
        lunghezzaDavanti: 73,
        polso: 23,
        spalle: 46,
        torace: 110,

        mezzoTorace: 22,

        puntoTorace: 21,
        mezzaManica: 24,
      },
    },
  },
};
